import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../utils/contants";

const BrandingContext = createContext({ isReady: false });
const baseUrl = (BASE_URL || "").replace(/\/$/, "");

const mediaUrl = (media) => {
  const url = media && media.url;
  if (typeof url !== "string" || !url.trim()) return null;
  if (/^https?:\/\//i.test(url)) return url;
  return `${baseUrl}${url.startsWith("/") ? "" : "/"}${url}`;
};

export const BrandingProvider = ({ children }) => {
  const [configuration, setConfiguration] = useState(null);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!baseUrl) {
      setIsReady(true);
      return undefined;
    }
    let active = true;
    axios.get(`${baseUrl}/configuracion-logos/publicado`, { timeout: 5000 })
      .then(({ data }) => {
        if (active) setConfiguration(data);
      })
      .catch(() => {
        // Si el CMS no responde, se conservan los recursos estáticos actuales.
      })
      .finally(() => {
        if (active) setIsReady(true);
      });
    return () => { active = false; };
  }, []);

  const branding = useMemo(() => ({
    isReady,
    logoCabecera: mediaUrl(configuration && configuration.logoCabecera),
    logoFooter: mediaUrl(configuration && configuration.logoFooter),
    loader: mediaUrl(configuration && configuration.loader),
    favicon: mediaUrl(configuration && configuration.favicon),
  }), [configuration, isReady]);

  useEffect(() => {
    if (!branding.favicon) return undefined;
    const favicon = document.querySelector("link[rel~='icon']");
    if (!favicon) return undefined;
    const previous = favicon.getAttribute("href");
    const image = new Image();
    let active = true;
    image.onload = () => {
      if (active) favicon.href = branding.favicon;
    };
    image.src = branding.favicon;
    return () => {
      active = false;
      favicon.setAttribute("href", previous);
    };
  }, [branding.favicon]);

  return <BrandingContext.Provider value={branding}>{children}</BrandingContext.Provider>;
};

export const useBranding = () => useContext(BrandingContext);
